import { render, staticRenderFns } from "./ReportPurchasesPerSupplierPage.vue?vue&type=template&id=2694d700&scoped=true"
import script from "./ReportPurchasesPerSupplierPage.vue?vue&type=script&lang=js"
export * from "./ReportPurchasesPerSupplierPage.vue?vue&type=script&lang=js"
import style0 from "./ReportPurchasesPerSupplierPage.vue?vue&type=style&index=0&id=2694d700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2694d700",
  null
  
)

export default component.exports